import * as React from "react";
import {ReactUtilities} from "shared/utilities/react/ReactUtilities";
import {CSSProperties} from "react";
import {WPBasicColumn} from "shared/controls/WPTable/Columns/WPBasicColumn";
export enum WPTableSortDirectionEnum{
    none='none',
    asc='asc',
    desc='desc'
}

export class WPTH extends React.Component<WordpressTableProps, WordpressTableState> {
    static defaultProps: Partial<WordpressTableProps> = {
        IsSortable:false,
        SortDirection:WPTableSortDirectionEnum.none,
        StickyOffset:0,
        StickyLeft:null
    };



    constructor(props: WordpressTableProps) {
        super(props);
        this.state = {
            SortDirection:'none'
        };
    }

    public render() {
        if(this.props.IsSortable)
            return this.CreateSortableColumn();
        return this.CreateNormalColumn();

    }

    private CreateSortableColumn() {
        let sortDirectionClass;

        switch (this.props.SortDirection) {
            case WPTableSortDirectionEnum.none:
                sortDirectionClass='sortable asc';
                break;
            case WPTableSortDirectionEnum.desc:
                sortDirectionClass='sorted asc';
                break;
            case WPTableSortDirectionEnum.asc:
                sortDirectionClass='sorted desc';
                break;
        }

        return (
            <th className={sortDirectionClass+' rnStickyHeader column-primary '+(this.props.IsNumeric?' rnNumeric':'')} style={{top:this.props.StickyOffset,left:this.props.StickyLeft,zIndex:(this.props.StickyLeft!=null?1:0),backgroundColor:'white',...this.props.Styles}}>
                {this.MaybeAddCheckBox()}
                <a style={{boxShadow:'none'}} href={'#'} onClick={e=>{e.preventDefault();this.SortingChanged()}}>
                    <span>{this.props.children}</span>
                    <span className={'sorting-indicator'}/>
                </a>
            </th>
        )
    }

    private CreateNormalColumn() {
        return (
            <th className={'column-primary rnStickyHeader'+(this.props.IsNumeric?' rnNumeric':'')} style={{top:this.props.StickyOffset,left:this.props.StickyLeft,zIndex:(this.props.StickyLeft!=null?1:0),backgroundColor:'white',...this.props.Styles}}>
                {this.MaybeAddCheckBox()}
                {this.props.children}
            </th>
        )
    }

    private SortingChanged() {
        let newDirection;
        if(this.props.SortDirection==WPTableSortDirectionEnum.desc)
            newDirection=WPTableSortDirectionEnum.asc;
        else
            newDirection=WPTableSortDirectionEnum.desc;
        ReactUtilities.ExecuteMethodPropIfDefined(this.props.SortingChanged,newDirection);
    }

    private MaybeAddCheckBox() {
        if(this.props.Column.props.HasCheckBox)
        {
            return <input type={'checkbox'} checked={!this.props.Data.some(x=>!x[this.props.Column.props.CheckBoxProperty])} style={{margin:'0 5px 0 0'}} onChange={x=>this.ToggleChecked(x.target.checked)}/>
        }

        return null;
    }

    private ToggleChecked(checked: boolean) {
        this.props.Data.forEach(x=>x[this.props.Column.props.CheckBoxProperty]=checked);
        this.props.CheckedChanged();
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface WordpressTableProps {
    IsSortable?:boolean;
    SortDirection?:WPTableSortDirectionEnum
    SortingChanged?:(direction:WPTableSortDirectionEnum)=>void;
    Styles:CSSProperties;
    StickyOffset:number;
    IsNumeric:boolean;
    StickyLeft:number;
    Column:WPBasicColumn;
    Data:any[];
    CheckedChanged:()=>void;

}

interface WordpressTableState {

}




//#endregion "My Region"